module.exports = __webpack_public_path__ + "static/media/51.5d42f0ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/51.svg
// module id = 170
// module chunks = 0